import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './styles.css'; // Подключаем CSS

import Header from './components/Header';
import Editor from './Editor';
import Article from './Article';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import { AuthContext } from './context/authContext';
import UserPage from './pages/UserPage';
import EditArticle from './pages/EditArticle';

function App() {
  const { user } = useContext(AuthContext);

  return (
    <div className="wrapper">
      <Header />
      <Routes>
        <Route path="/" element={user?.token ? <Editor /> : <Navigate to="/auth/login" />} />
        <Route path="/articles/:slug" element={<Article />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route
          path="/edit/:slug"
          element={user?.token ? <EditArticle /> : <Navigate to="/auth/login" />}
        />
        <Route path="/user" element={user?.token ? <UserPage /> : <Navigate to="/auth/login" />} />
      </Routes>
    </div>
  );
}

export default App;
